import { useEffect, useState } from "react";
import { CaretUpOutlined,CaretDownOutlined} from "@ant-design/icons";
import Img from '../assets/images/Capture11.PNG';
// import { useHistory } from 'react-router-dom';
import Lottie from 'lottie-react';
import {get} from "../Libraries/Ajax/HttpService";
import {
  Card,
 
  Button,
  } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import systemflow from '../components/systemflow.json';
import systemflowgreens from '../components/systemflowgreen.json';
import { useNavigate } from 'react-router-dom';


function MccordDashboard() {
  
  const [first, setFirst] = useState(false);
  const [optionone, setOptionone] = useState(null);
  const [optiontwo, setOptiontwo] = useState(null);
  const [optionfour, setOptionfour] = useState(true);
  
  const [selected, setSelected] = useState('week');
  const [percentage, setPercentage] = useState(null);
  const myData = [
    { x: "No Recent Flow", y: 900 },
    { x: "Leak Detected", y: 400 },
    { x: "Backflow", y: 300 },
  ];
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: systemflow,
    renderer: 'svg'
  }
  const defaultOptionsNew = {
    loop: true,
    autoplay: true,
    animationData: systemflowgreens,
    renderer: 'svg'
  }
  // let history = useHistory();
  const navigate = useNavigate();
 
  useEffect(() => {
    get(
        `apis/system_usage?option=${selected}`

      ).then(res => {
        setPercentage(res.data.data.systemusage.percentage);
        setFirst(true);
        setOptionone(res.data.data.systemusage.flow);
        setOptiontwo(res.data.data.systemusage.flow_pre);
        setOptionfour(res.data.data.systemusage.percentage_arrow_down);

      });
    

  }, [selected]);


  const onMouseClick = event => {
    setSelected(event.target.value);
    console.log(selected);
  };
  const onCardClick = event => {
    // history.push('/dashboard')
      navigate('/dashboard');
  };
  return (
    <>
    {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div className="layout-content">
          <div class="container-fluid pb-0 px-0 flex-column">

            <div class="row gy-4">
              <div class="col-lg-6">
                <div class="water_parking water-main-section">
                  <Card bordered={false} className="criclebox h-full">

                    <div className="d-flex justify-content-between pb-2" >
                      <h2 className="text-blue mb-0 fw-bold">Water Visualization</h2>
                      <select name="All meters" id="selector" className="box" onChange={onMouseClick}>
                        <option value="week" selected>Week</option>
                        <option value="month" >Month </option>
                        <option value="year">Year</option>
                      </select>
                    </div>
                    <span onClick={onCardClick}>
                      <h3 className="pb-2 border-bottom mb-3">System Water Usage</h3>
                      <div className="d-flex responsive-direction align-items-start justify-content-between">
                        {/* <div className="w-50 system-water"> */}
                        <div className="system-water">
                          <h4 className="fw-400 text-grey mb-0">Weekly Usage(Gallons/Week)<span className="text-blue">*</span></h4>
                          <p className="text-gray fw-400 fs-14"><span className="text-blue">*</span>This metric is calculated from networked meters only</p>
                          <p></p>
                          <p></p>
                          <div className="d-flex justify-content-between flex-wrap">
                            <div className="dashboard-water water-usage-button d-flex align-items-center">
                              <Button type="btn" className="border-0 shadow-0">
                                <div className="this_week">
                                  {selected === "week" ?
                                    <span className="txt-week">This Week</span> : ""}
                                  {selected === "month" ?
                                    <span className="txt-week">This Month</span> : ""}
                                  {selected === "year" ?
                                    <span className="txt-week">This Year</span> : ""}

                                  <span className="usage-number">{optionone}</span>
                                  <span className="txt-gallon">Gallons</span>
                                </div>
                              </Button>
                              <span className="slashBorder">/</span>
                              <Button type="btn" className="border-0 shadow-0">
                                <div className="last_week">
                                  {selected === "week" ?
                                    <span className="txt-week">Last Week</span> : ""}
                                  {selected === "month" ?
                                    <span className="txt-week">Last Month</span> : ""}
                                  {selected === "year" ?
                                    <span className="txt-week">Last Year</span> : ""}
                                  <span className="usage-number">{optiontwo}</span>
                                  <span className="txt-gallon">Gallons</span>
                                </div>
                              </Button>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 w-50 d-flex flex-column justify-content-center gap-3 values-set">


                          {optionfour === false ? <div className="uparrow">
                            <Lottie
                              options={defaultOptions}
                              height={100}
                              width={100}
                            />
                          </div> :
                            <div className="downarrow">
                              <Lottie
                                options={defaultOptionsNew}
                                height={150}
                                width={150}

                              />
                            </div>
                          }
                          {optionfour === false ? <div className="increased-values arrowWater">{percentage}<CaretUpOutlined style={{ color: 'red' }} /></div> :
                            <div className="increased-values arrowWater">{percentage}<CaretDownOutlined style={{ color: 'green' }} /></div>}
                        </div>
                      </div>
                    </span>
                  </Card>

                </div>
              </div>
              <div class="col-lg-6">
                <div class="water_parking water-main-section">
                  <Card bordered={false} className="criclebox h-full" >
                    <div className="d-flex justify-content-between  pb-2">
                      <h2 className="text-green mb-0 fw-bold">Parking Visualization</h2>
                      <select name="All meters" id="selector" className="box" onChange={onMouseClick}>
                        <option value="week" selected>Week</option>
                        <option value="month" >Month </option>
                        <option value="year">Year</option>
                      </select>
                    </div>
                    <h3 className="pb-2 border-bottom">Parking System Usage</h3>
                    <div className="box-flex responsive-direction justify-content-between">
                      <div className="">
                        <h4 className="fw-400 text-grey mb-0">Weekly Utilization<span className="text-blue">*</span></h4>
                        <p className="text-gray fw-400 fs-12"><span className="text-blue">*</span>Parking occupancy changes will be displayed instantly</p>
                        <p className="text-gray fw-400 fs-14 text-blue mb-0"><span className="text-blue">Occupied spaces:13</span></p>
                        <p className="text-gray fw-400 fs-14 text-red">Unoccupied spaces:15</p>
                        <div className="d-flex justify-content-between flex-wrap">
                          <div className="dashboard-water water-usage-button d-flex align-items-center">
                            <Button type="btn" className="border-0 shadow-0">
                              <div className="this_week">
                                <span className="txt-week">This Week</span>
                                <span className="usage-number">54%</span>
                                {/* <span className="txt-gallon">%</span>*/}
                              </div>
                            </Button>
                            <span className="slashBorder">/</span>
                            <Button type="btn" className="border-0 shadow-0">
                              <div className="last_week">
                                <span className="txt-week">Last Week</span>
                                <span className="usage-number">49%</span>
                                {/* <span className="txt-gallon">%</span> */}
                              </div>
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="w-50 text-center values-set">
                        {optionone > optiontwo ? <div className="uparrow">
                          <Lottie
                            options={defaultOptions}
                            height={150}
                            width={150}
                          />
                        </div> :
                          <div className="downarrow">
                            <Lottie
                              options={defaultOptionsNew}
                              height={150}
                              width={150}

                            />
                          </div>
                        }
                        {optionone > optiontwo ? <div className="increased-values arrowWater mt-3">{percentage}<CaretUpOutlined style={{ color: 'red' }} /></div> :
                          <div className="increased-values arrowWater mt-3">{percentage}<CaretDownOutlined style={{ color: 'green' }} /></div>}

                      </div>
                    </div>
                  </Card>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="water_parking water-main-section">
                  <Card bordered={false} className="criclebox h-full">
                    <div className="d-flex justify-content-between border-bottom mb-3">
                      <div>
                        <h2 className="text-blue mb-2 fw-bold"><font color="#ff8c00">Parks Visualization</font></h2>
                        <h3 className="border-bottom-0">Parks Data Usage</h3>
                      </div>
                      <div className="d-flex flex-column">
                        <select name="All meters" id="selector" className="box w-100 mb-2" 
                        // onChange={onMouseClick}
                        >
                          <option value="week" selected>Week</option>
                          <option value="month" >Month </option>
                          <option value="year">Year</option>
                        </select>
                        <select name="All meters" id="selector" className="box w-100" 
                        // onChange={onMouseClick}
                        >
                          <option value="week" selected>Licata Pedestrian Bridge</option>
                          <option value="month" >MLP-A </option>
                          <option value="year">MLP-B</option>
                        </select>
                      </div>
                    </div>
                    <div className="box-flex responsive-direction justify-content-between">
                      <div className="">
                        <h4 className="fw-400 text-grey mb-0">Licata Pedestrian Bridge<span className="text-blue">*</span></h4>
                        <p className="text-gray fw-400 fs-14"><span className="text-blue">*</span>Parking occupancy changes will be displayed instantly</p>
                        <p className="text-gray fw-400 fs-14 text-blue mb-0"><span className="text-blue">Licata Pedestrian Bridge:1382</span></p>
                        <p className="text-gray fw-400 fs-14 text-blue"><span className="text-blue">Cyclist IN:4</span></p>
                        <div className="d-flex justify-content-between flex-wrap">
                          <div className="dashboard-water water-usage-button d-flex align-items-center">
                            <Button type="btn" className="border-0 shadow-0">
                              <div className="this_week">
                                <span className="txt-week">This Week</span>
                                <span className="usage-number">1000k</span>
                                <span className="txt-gallon">Gallons</span>                                                    
                              </div>
                            </Button>
                            <span className="slashBorder">/</span>
                            <Button type="btn" className="border-0 shadow-0">
                              <div className="last_week">
                                <span className="txt-week">Last Week</span>
                                <span className="usage-number">2356k</span>
                                <span className="txt-gallon">Gallons</span>
                              </div>
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="w-50 text-center values-set">
                        {optionfour === false ? <div className="uparrow">
                          <Lottie
                            options={defaultOptions}
                            height={100}
                            width={100}
                          />
                        </div> :
                          <div className="downarrow">
                            <Lottie
                              options={defaultOptionsNew}
                              height={150}
                              width={150}

                            />
                          </div>
                        }
                        {optionfour === false ? <div className="increased-values arrowWater mt-3">{percentage}<CaretUpOutlined style={{ color: 'red' }} /></div> :
                          <div className="increased-values arrowWater mt-3">{percentage}<CaretDownOutlined style={{ color: 'green' }} /></div>}

                      </div>
                    </div>
                  </Card>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="water-parking">
                  <Card bordered={false} className="criclebox h-full">
                    <div className="d-flex flex-wrap">
                      <div >
                        <img src={Img} width="1000" height="340" />
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>

      </Main>
    </>
  );
}

export default MccordDashboard;
